import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "ai-message" }
const _hoisted_2 = { class: "inner-content" }
const _hoisted_3 = {
  key: 0,
  class: "internal-badge"
}
const _hoisted_4 = { class: "text-controls" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "suggestions delay-in-1000" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Research = _resolveComponent("Research")
  const _component_Cards = _resolveComponent("Cards")
  const _component_Answer = _resolveComponent("Answer")
  const _component_AiEditor = _resolveComponent("AiEditor")
  const _component_Widgets = _resolveComponent("Widgets")
  const _component_AiFile = _resolveComponent("AiFile")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_SaveDoc = _resolveComponent("SaveDoc")
  const _component_IconLike = _resolveComponent("IconLike")
  const _component_Feedback = _resolveComponent("Feedback")
  const _component_IconDislike = _resolveComponent("IconDislike")
  const _component_Logo = _resolveComponent("Logo")
  const _component_FileIcon = _resolveComponent("FileIcon")
  const _component_Image = _resolveComponent("Image")
  const _component_SourceType = _resolveComponent("SourceType")
  const _component_SourcesSection = _resolveComponent("SourcesSection")
  const _component_AiSugggestion = _resolveComponent("AiSugggestion")
  const _component_SourcesModal = _resolveComponent("SourcesModal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Research, {
        ref: "answer-tabs",
        completed: $options.completed,
        "chat-id": $props.chatId,
        reasoning: $options.reasoning,
        class: "research",
        mode: "expanded"
      }, null, 8 /* PROPS */, ["completed", "chat-id", "reasoning"]),
      ($options.cards?.length)
        ? (_openBlock(), _createBlock(_component_Cards, {
            key: 0,
            class: "cards",
            cards: $options.cards,
            loading: $options.self_loading,
            sources: $options.sources,
            readonly: $props.readonly
          }, null, 8 /* PROPS */, ["cards", "loading", "sources", "readonly"]))
        : _createCommentVNode("v-if", true),
      ($props.item.data?.text)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            ($options.self_loading)
              ? (_openBlock(), _createBlock(_component_Answer, {
                  key: 0,
                  ref: "answer",
                  class: "answer",
                  restricted: $props.restricted,
                  "last-answer": $props.lastAnswer,
                  text: $options.text,
                  generating: $props.generating,
                  intermediate: $options.intermediate,
                  onTextAdded: $options.onTextAdded
                }, null, 8 /* PROPS */, ["restricted", "last-answer", "text", "generating", "intermediate", "onTextAdded"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  ($options.is_editor)
                    ? (_openBlock(), _createBlock(_component_AiEditor, {
                        key: 0,
                        class: "editor",
                        "post-text": $props.item.data.text,
                        loading: $props.generating,
                        onSave: _cache[0] || (_cache[0] = $event => (_ctx.$emit('save', $event))),
                        onRefrag: _cache[1] || (_cache[1] = $event => (_ctx.$emit('refrag', $event)))
                      }, null, 8 /* PROPS */, ["post-text", "loading"]))
                    : (_openBlock(), _createBlock(_component_Answer, {
                        key: 1,
                        ref: "answer",
                        class: "answer",
                        restricted: $props.restricted,
                        "last-answer": $props.lastAnswer,
                        generating: $props.generating,
                        text: $options.text
                      }, null, 8 /* PROPS */, ["restricted", "last-answer", "generating", "text"]))
                ], 64 /* STABLE_FRAGMENT */))
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      ($data.render_widgets && !!$options.widgets?.length)
        ? (_openBlock(), _createBlock(_component_Widgets, {
            key: 2,
            ref: "widgets_export",
            class: "widgets-export",
            widgets: $options.widgets,
            snapshot: ""
          }, null, 8 /* PROPS */, ["widgets"]))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.file_download, (id) => {
        return (_openBlock(), _createBlock(_component_AiFile, {
          id: id,
          key: id,
          restricted: $props.restricted,
          class: "file-cards"
        }, null, 8 /* PROPS */, ["id", "restricted"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    (!$options.self_loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($options.internal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_Icon, {
                  class: "alert-icon",
                  icon: "alert-circle",
                  stroke: "var(--error-700)",
                  size: "1.8rem"
                }),
                _cache[9] || (_cache[9] = _createTextVNode(" This AI response might contain internal company information. Do not share externally. "))
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_4, [
            ($props.item.data?.text && !$options.is_editor)
              ? (_openBlock(), _createBlock(_component_Tooltip, {
                  key: 0,
                  text: "Copy"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      icon: "copy",
                      hoverable: "",
                      stroke: "var(--brand-700)",
                      class: "icon pointer",
                      "stroke-width": "1",
                      size: "1.6rem",
                      onClick: _cache[2] || (_cache[2] = $event => ($options.copyAnswer()))
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (!$props.readonly && !$props.item.data?.file_download && !$options.is_editor)
              ? (_openBlock(), _createBlock(_component_SaveDoc, {
                  key: 1,
                  disabled: $props.generating,
                  class: "save-doc",
                  size: "1.6rem",
                  color: "var(--gray-700)",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                  onSave: _cache[4] || (_cache[4] = $event => (_ctx.$dispatch('document-save', {ext: $event})))
                }, null, 8 /* PROPS */, ["disabled"]))
              : _createCommentVNode("v-if", true),
            (!$props.readonly)
              ? (_openBlock(), _createBlock(_component_Tooltip, {
                  key: 2,
                  text: "Good answer"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Feedback, {
                      "show-popover": !$options.liked,
                      onSend: _cache[5] || (_cache[5] = $event => (_ctx.$emit('like', $event)))
                    }, {
                      default: _withCtx(({visible}) => [
                        _createVNode(_component_IconLike, {
                          class: "pointer",
                          hoverable: "",
                          hover: visible,
                          "stroke-width": "1",
                          size: "1.6rem",
                          liked: $options.liked,
                          stroke: "var(--gray-700)",
                          icon: "thumbs-up"
                        }, null, 8 /* PROPS */, ["hover", "liked"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["show-popover"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (!$props.readonly)
              ? (_openBlock(), _createBlock(_component_Tooltip, {
                  key: 3,
                  text: "Bad answer"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Feedback, {
                      "show-popover": !$options.disliked,
                      onSend: _cache[6] || (_cache[6] = $event => (_ctx.$emit('dislike', $event)))
                    }, {
                      default: _withCtx(({visible}) => [
                        _createVNode(_component_IconDislike, {
                          class: "pointer",
                          hoverable: "",
                          hover: visible,
                          "stroke-width": "1",
                          size: "1.6rem",
                          disliked: $options.disliked,
                          stroke: "var(--gray-700)",
                          icon: "thumbs-down"
                        }, null, 8 /* PROPS */, ["hover", "disliked"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["show-popover"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", {
              class: "pulse-sources pointer",
              underline: "",
              onClick: _cache[7] || (_cache[7] = (...args) => ($options.openSources && $options.openSources(...args)))
            }, [
              _createVNode(_component_SourcesSection, {
                class: "pointer",
                sources: $options.sources,
                "show-text": false,
                "view-count": 4
              }, {
                image: _withCtx(({source}) => [
                  (source.type === 'genrate')
                    ? (_openBlock(), _createBlock(_component_Logo, {
                        key: 0,
                        size: "1.6rem"
                      }))
                    : (source.type === 'file')
                      ? (_openBlock(), _createBlock(_component_FileIcon, {
                          key: 1,
                          "font-size": "0.3rem",
                          width: "1.6rem",
                          height: "1.6rem",
                          ext: source.name.split('.').pop()
                        }, null, 8 /* PROPS */, ["ext"]))
                      : (source.logo_url)
                        ? (_openBlock(), _createBlock(_component_Image, {
                            key: 2,
                            src: source.logo_url,
                            size: "1.6rem",
                            placeholder: "assets/company-placeholder.png",
                            shape: "circle"
                          }, null, 8 /* PROPS */, ["src"]))
                        : (_openBlock(), _createBlock(_component_SourceType, {
                            key: 3,
                            type: source.type,
                            internal: source.internal,
                            "show-title": false
                          }, null, 8 /* PROPS */, ["type", "internal"]))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["sources"]),
              _cache[10] || (_cache[10] = _createTextVNode(" Sources "))
            ])
          ]),
          (!$props.readonly && $options.suggestions)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                disabled: $props.generating
              }, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "segment-title more" }, [
                  _createElementVNode("span", null, "More suggestions")
                ], -1 /* HOISTED */)),
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.suggestions, (suggestion, i) => {
                    return (_openBlock(), _createBlock(_component_AiSugggestion, {
                      key: i,
                      suggestion: suggestion,
                      onAskAi: _cache[8] || (_cache[8] = $event => (_ctx.$emit('ask-ai', $event)))
                    }, null, 8 /* PROPS */, ["suggestion"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ], 8 /* PROPS */, _hoisted_5))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_SourcesModal, {
      ref: "sources",
      sources: $options.sources
    }, null, 8 /* PROPS */, ["sources"])
  ]))
}